import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PageTransition } from "@/components/PageTransition";
import { IPhoneComparisonStandalone } from "@/components/IPhoneComparisonStandalone";
import { BottomNavigation } from "@/components/BottomNavigation";
import { MenuDrawer } from "@/components/MenuDrawer";
import { useTheme } from "@/hooks/useTheme";
import { supabase } from "@/integrations/supabase/client";

const ConfrontaIPhone = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [userId, setUserId] = useState<string | null>(null);
  const { preference } = useTheme();

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => {
      setUserId(data.user?.id || null);
    });
  }, []);

  // Determine if dark mode is active for bottom nav variant
  const isDark = preference === "dark" || (preference === "auto" && (new Date().getHours() < 6 || new Date().getHours() >= 18));

  return (
    <PageTransition>
      <div className="confronta-no-images">
        <IPhoneComparisonStandalone onBack={() => navigate(-1)} />
      </div>
      {userId && (
        <>
          <MenuDrawer open={menuOpen} onOpenChange={setMenuOpen} />
          <BottomNavigation
            onMenuClick={() => setMenuOpen((v) => !v)}
            menuOpen={menuOpen}
            activeTab="confronta"
            variant={isDark ? "dark" : "light"}
          />
        </>
      )}
      <style>{`
        .confronta-no-images img,
        .confronta-no-images [class*="phone-img"],
        .confronta-no-images [class*="device-image"] { display: none !important; }
      `}</style>
    </PageTransition>
  );
};

export default ConfrontaIPhone;
